import Criteria from 'components/common/helpMeDecide/Criteria';
import React, { ComponentType } from 'react';

interface WithCriteriaProps {
  numberOfCriteria: number;
  loading?: boolean;
  minHeight?: string;
  onContinue: () => void;
  onBack: () => void;
}

// HOC that has common info between  custom Criteria components
const withCriteria = <P extends Record<string, unknown>>(
  Component: ComponentType<P & WithCriteriaProps>,
  currentIndex: number,
): ComponentType<P & WithCriteriaProps> => {
  const WithCriteria: React.FC<P & WithCriteriaProps> = (props) => {
    const { numberOfCriteria, onContinue, onBack, loading = false, minHeight = '' } = props;

    return (
      <Criteria
        currentIndex={currentIndex}
        totalQuantity={numberOfCriteria}
        loading={loading}
        onContinue={onContinue}
        onBack={onBack}
        minHeight={minHeight}
      >
        <Component {...props} />
      </Criteria>
    );
  };

  return WithCriteria;
};

export default withCriteria;
